import React from 'react'
import {SetBannerTitle} from '../../layouts/components/BannerTitle'

const Page = () => (
  <React.Fragment>

    <SetBannerTitle value={"Network Infrastructure Design"} />

    <div className="services-content">
      <section className="divided-section-content">
        <p>If selected as your design-build contractor, you will have one point of contact from the evolution to the completion of a project. This method not only saves our customers money, it decreases the overall duration of a project to meet challenging deadlines.</p>
        <p>Our on-staff BICSI Registered Communications Distribution Designer (RCDD) and industry experts can offer value-engineered advantages to provide cost-savings for any solution. We believe transparency is a vital key to the success of a project and all details will be communicated during its conception.</p>
      </section>
    </div>
  </React.Fragment>
)

export default Page



// WEBPACK FOOTER //
// ./src/pages/design/network-infrastructure.js